import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import DocumentViewer from "components/bid_module/DocumentViewer";
import { AnswerSource } from "components/bid_module/types";
import Button from "components/ui/button/Button";
import Drawer from "components/ui/drawer/Drawer";
import toast from "components/ui/toast/Toast";
import { FileViewerContextProvider } from "lib/core_components/FileViewer";
import { useLogEntityViewOnOpen } from "lib/hooks/api/userActivity/useLogEntityView";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { LoggedEntityType } from "lib/types/graphQLEnums";
import { useCustomerDocumentUrls } from "../../lib/hooks/api/customer_documents/useCustomerDocumentUrls";

type Props = {
  // TODO: Change to a more common source type
  source?: AnswerSource | null;
  isOpen: boolean;
  onClose: () => void;
};

export function CustomerDocumentDrawer({ source, onClose, isOpen }: Props) {
  const { data } = useCustomerDocumentUrls([source?.documentId ?? ""], {
    enabled: !!source?.documentId,
    onError: () => {
      toast.error("Failed to load document");
    },
  });
  const documentUrl = data?.[0]?.documentUrl;
  useLogEntityViewOnOpen(
    LoggedEntityType.CustomerDocument,
    isOpen ? source?.documentId : undefined,
  );

  // TODO: This should be done in the backend
  let fileExtension = source?.fileName?.split(".").pop() || "";
  if (["odt", "odp", "ods"].includes(fileExtension)) {
    fileExtension = "pdf";
  }

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      width={1200}
    >
      <FileViewerContextProvider key={`${documentUrl}-${+true}`}>
        <PreviewWrapper>
          <Controls>
            <Button
              buttonType="secondary"
              title="Close"
              icon="chevronRightDouble"
              onClick={onClose}
            />
          </Controls>
          {documentUrl && source ? (
            <DocumentViewer
              documentUrl={documentUrl}
              fileExtension={fileExtension}
              source={source}
              open={true}
            />
          ) : (
            <Flex alignItems="center" justifyContent="center" width="100%">
              <UIcon icon="spinner" size={32} />
            </Flex>
          )}
        </PreviewWrapper>
      </FileViewerContextProvider>
    </Drawer>
  );
}

const PreviewWrapper = styled(Flex)({
  paddingRight: 16,
  height: "100vh",
  overflow: "hidden",
});

const Controls = styled(Flex)(({ theme }) => ({
  flexDirection: "column",
  alignItems: "center",
  borderRight: `1px solid ${theme.colors.sysBorderDecorative}`,
  height: "100vh",
  padding: 16,
}));
